const validateAgencyName = ({ name = '' }) => {
  if (name.length < 1) {
    return 'Agency Name is required.';
  }

  return '';
};

const validatePartnerId = ({ partnerID = '' }) => {
  if (partnerID.length < 1) {
    return 'Partner Id is required.';
  }

  return '';
};

const validatePartnerAgencyId = ({ partnerAgencyID = '' }) => {
  if (partnerAgencyID.length < 1) {
    return 'Partner Agency Id is required.';
  }

  return '';
};

const validate = (values = {}) => [
  validateAgencyName(values),
  validatePartnerId(values),
  validatePartnerAgencyId(values),
];

export default validate;
